import { render } from "./SvgCanvas.vue?vue&type=template&id=34c33bb1&ts=true"
import script from "./SvgCanvas.vue?vue&type=script&lang=ts"
export * from "./SvgCanvas.vue?vue&type=script&lang=ts"

import "./SvgCanvas.vue?vue&type=style&index=0&id=34c33bb1&lang=css"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__